module.exports = __webpack_public_path__ + "img/VE.657b3897.svg";